import PropTypes from 'prop-types';

// Note: any camelCase names here are all-lowercase in HTML. It's just React JSX
// that camelcases them, so for example `autocomplete` in HTML becomes
// `autoComplete` in React.
export const InputPropTypes = {
    autoComplete: PropTypes.string,
    autoFocus: PropTypes.bool,
    maxLength: PropTypes.number,
    placeholder: PropTypes.string,
    readOnly: PropTypes.bool,
    required: PropTypes.bool,
    size: PropTypes.number,
    value: PropTypes.any,
};

export type InputProps = {
    autoComplete?: HTMLInputElement['autocomplete'];
    autoFocus?: HTMLInputElement['autofocus'];
    maxLength?: HTMLInputElement['maxLength'];
    placeholder?: HTMLInputElement['placeholder'];
    readOnly?: HTMLInputElement['readOnly'];
    required?: HTMLInputElement['required'];
    size?: HTMLInputElement['size'];
    value?: HTMLInputElement['value'];
};
